import React, { useEffect } from 'react';
import { LandingComponent } from 'app/types';

import { dynamicScripts } from 'common/utils';
import { useMediaQuery } from 'react-responsive';
import textStyles from 'common/styles/text.module.scss';
import { Newsletter } from 'assets/landing/index';
import styles from 'features/landing/Landing.module.scss';

interface PreviewComponentProps {
  landing_cmp: LandingComponent;
}

const NewsletterBannerPreview = ({ landing_cmp }: PreviewComponentProps): React.ReactElement => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div
      id={landing_cmp.html_id}
      key={landing_cmp.id}
      className={landing_cmp.class_name}
      style={{
        width: landing_cmp.size !== 'sm' && landing_cmp.size !== 'md' ? landing_cmp.size : 'auto',
        padding: landing_cmp.size === 'sm' ? '0 12rem' : '0 4vw',
        margin: landing_cmp.gap,
        background: !(landing_cmp.background instanceof File) ? landing_cmp.background : 'auto',
        backgroundImage: `url(${landing_cmp.background_image})`,
        backgroundSize: landing_cmp.background_size,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '360px',
      }}
    >
      <div className={styles.newsletterConatiner}>
        {isMobile && (
          <div>
            <img src={Newsletter} className={styles.bgNewsletterContainer} alt="newsletter_bg" />
          </div>
        )}
        <div
          className={`${
            isMobile
              ? 'd-flex flex-column align-items-center'
              : 'col-6 d-flex flex-column align-items-start ms-5'
          } pt-4`}
        >
          <p
            className={`${
              isMobile ? textStyles['text-secondary-18-600'] : textStyles['text-secondary-40-600']
            }`}
            style={{ textAlign: 'left' }}
          >
            {landing_cmp.config.title}
          </p>
          <p
            className={`${
              isMobile ? textStyles['text-secondary-14-400'] : textStyles['text-secondary-20-400']
            }`}
            style={{ maxWidth: '70%', textAlign: `${isMobile ? 'center' : 'left'}` }}
          >
            {landing_cmp.config.banner_text}
          </p>
        </div>
        {isMobile ? (
          <div>
            <div className={`mt-4 pb-5 newsletterForm ${styles.customSearch}`}>
              <form>
                <input className={`${styles.customSearchInput}`} placeholder="Email" />
                <button className={`btn btn-primary ${styles.customSearchButton}`} type="submit">
                  <p style={{ fontWeight: 700, fontSize: 16 }}>{landing_cmp.config.button_text}</p>
                </button>
              </form>
            </div>
          </div>
        ) : (
          <div className="col-6 d-flex flex-column align-items-center">
            <div className={`mt-5 pb-5 newsletterForm ${styles.customSearch}`}>
              <form>
                <input className={`${styles.customSearchInput}`} placeholder="Enter your email" />
                <button className={`btn btn-primary ${styles.customSearchButton}`} type="submit">
                  <p style={{ fontWeight: 700, fontSize: 16 }}>{landing_cmp.config.button_text}</p>
                </button>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewsletterBannerPreview;
